import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MeetingRoomsKioskState } from "./reducer";
import { IMeetingRoomKioskData } from "../models/kiosk.model";
const getState =
  createFeatureSelector<MeetingRoomsKioskState>("meetingRoomsKiosk");

export const kioskSelectors = {
  meetingRoomKioskData: createSelector(
    getState,
    (state) => state.meetingRoomKioskData as IMeetingRoomKioskData,
  ),
  eventDetails: createSelector(getState, (state) => state.eventDetails),
};
